<app-side-dialog class="min-w-[700px]" [disableClose]="true" (closeDialog)="onCloseClick()">
  <div dialogHeader class="flex items-center justify-between w-full gap-3">
    <h2 class="min-w-0 truncate">
      {{ 'dialogs.createCampaignDialog.briefWizard.title' | translate }}
    </h2>

    @if (stops().length) {
      <span
        class="text-shikenso-purple-base-60 text-sm whitespace-nowrap shrink-0"
        data-testid="brief-wizard-step-counter"
      >
        {{
          'dialogs.createCampaignDialog.briefWizard.stepCounter'
            | translate: { current: currentStopIndex() + 1, total: stops().length }
        }}
      </span>
    }
  </div>

  <div dialogContent class="flex flex-col gap-6 custom-form">
    @let stop = currentStop();

    @if (currentCtaTemplateName()) {
      <p class="text-xl font-bold">
        <span class="font-normal">{{ 'dialogs.createCampaignDialog.briefWizard.fixingIssueFor' | translate }}</span
        >{{ currentCtaTemplateName() }}
      </p>
    }

    @if (currentBasicsFieldName()) {
      <p class="text-xl font-bold">
        <span class="font-normal">{{
          'dialogs.createCampaignDialog.briefWizard.fixingCampaignDetails' | translate
        }}</span
        >{{ currentBasicsFieldName() }}
      </p>
    }

    @if (stop) {
      @switch (stop.kind) {
        @case ('basicsDates') {
          <app-brief-basics-dates-step
            [initialValue]="currentBasicsDatesValue()"
            (stateChange)="onStepStateChange($event)"
          />
        }

        @case ('basicsName') {
          <app-brief-basics-field-step
            kind="basicsName"
            [initialValue]="currentBasicsFieldValue()"
            (stateChange)="onStepStateChange($event)"
          />
        }

        @case ('basicsNotes') {
          <app-brief-basics-field-step
            kind="basicsNotes"
            [initialValue]="currentBasicsFieldValue()"
            (stateChange)="onStepStateChange($event)"
          />
        }

        @case ('basicsBudget') {
          <app-brief-basics-field-step
            kind="basicsBudget"
            [initialValue]="currentBasicsFieldValue()"
            (stateChange)="onStepStateChange($event)"
          />
        }

        @case ('platform') {
          <app-brief-platform-step
            [initialValue]="currentPlatformValue()"
            [existingDeliverableTypes]="currentPlatformExistingDeliverableTypes()"
            (stateChange)="onStepStateChange($event)"
          />
        }

        @case ('deliverable') {
          @if (currentGamePlaysTooLong(); as gamePlaysTooLong) {
            <p class="text-base">
              {{ 'dialogs.createCampaignDialog.briefWizard.gamePlaysTooLong' | translate: gamePlaysTooLong }}
            </p>
          }

          @if (currentDeliverableType()) {
            <!-- Keyed on the stop's own identity (not just its type) so Angular fully destroys
                 and recreates the leaf deliverable component - and everything nested inside it,
                 including its own app-file-uploader - when moving to a different deliverable of
                 the SAME type, instead of reusing the instance and leaking its internal state
                 (e.g. a previously-selected image) across two unrelated "visual" errors. -->
            @for (stopKey of [currentStopKey()]; track stopKey) {
              <app-brief-deliverable-item-step
                [type]="currentDeliverableType()!"
                [initialValue]="currentDeliverableValue()"
                [platformFeature]="currentTemplatePlatformFeature()"
                (stateChange)="onStepStateChange($event)"
              />
            }
          }
        }

        @case ('execution') {
          @for (stopKey of [currentStopKey()]; track stopKey) {
            <app-brief-execution-item-step
              [initialValue]="currentExecutionValue()"
              [platformFeature]="currentTemplatePlatformFeature()"
              [gamePlaysDuration]="currentGamePlaysDuration()"
              [campaignStart]="campaignStartDate()"
              [campaignEnd]="campaignEndDate()"
              (stateChange)="onStepStateChange($event)"
            />
          }
        }
      }
    }

    <div class="flex justify-end gap-3">
      <button
        mat-flat-button
        color="secondary-transparent"
        type="button"
        data-testid="brief-wizard-cancel-button"
        [disabled]="validating()"
        (click)="onCloseClick()"
      >
        {{ 'shared.cancel' | translate }}
      </button>

      @if (currentStopIndex() > 0) {
        <button
          mat-flat-button
          color="secondary-transparent"
          type="button"
          data-testid="brief-wizard-back-button"
          [disabled]="validating()"
          (click)="onBackClick()"
        >
          {{ 'dialogs.createCampaignDialog.briefWizard.back' | translate }}
        </button>
      }

      <button
        mat-flat-button
        type="button"
        data-testid="brief-wizard-next-button"
        [disabled]="validating()"
        (click)="onNextClick()"
      >
        <p [class.hidden]="validating()">
          {{
            (isLastStop()
              ? 'dialogs.createCampaignDialog.briefWizard.fix'
              : 'dialogs.createCampaignDialog.briefWizard.next'
            ) | translate
          }}
        </p>

        @if (validating()) {
          <app-dots-spinner />
        }
      </button>
    </div>
  </div>
</app-side-dialog>
